import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Banner from '@zenbusiness/zui/Banner';
import Chip from '@zenbusiness/zui/Chip';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { useProductLandingContext } from '../../contexts/useProductLanding';
import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

const externalLink = (chunks, link, personalizationClickstreamProps) => (
  <Link
    clickstreamProps={{
      ...personalizationClickstreamProps,
      elementName: 'banner_link',
      elementPosition: 'banner',
    }}
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    textDecoration="none"
    color="text.secondary"
  >
    {chunks}
  </Link>
);

function BannerSection() {
  const { formatMessage: fm } = useIntl();
  const personalizationClickstreamProps = useProductLandingClickstreamProps();
  const { productConfig } = useProductLandingContext();
  const { banner } = productConfig;

  if (!banner?.title) {
    return null;
  }

  const { title, variant = 'info', chipLabel, footer } = banner;

  const slots = chipLabel
    ? {
        startIcon: (
          <Chip size="lg" color="secondary">
            <Text size="xl" weight="medium">
              <FormattedMessage id={chipLabel} />
            </Text>
          </Chip>
        ),
      }
    : undefined;

  return (
    <Stack direction="column" alignItems="center" gap={1}>
      <Banner
        variant={variant}
        title={fm({ id: title })}
        slots={slots}
        sx={{
          justifyItems: 'center',
          '.ZuiBanner-startIcon': { maxWidth: '100%' },
        }}
      />
      {footer && (
        <Text size="xs">
          <FormattedMessage
            id={footer.text}
            values={{
              externalLink: (chunks) => externalLink(chunks, footer.link, personalizationClickstreamProps),
            }}
          />
        </Text>
      )}
    </Stack>
  );
}

export default BannerSection;
